import React, { Component } from "react";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import "bootstrap/dist/js/bootstrap.bundle";
import { Link, useHistory } from "react-router-dom";
import Select, { AriaOnFocus } from "react-select";
// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import AsyncSelect from "react-select/async";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {
  getPartyApi,
  getMachineOperatorStock,
  getUserByRoleId,
  getUserApi,
  getAssignCubesFillerToMachinOperators,
  getCube,
} from "api";
import { withTranslation } from "react-i18next";
import { map } from "lodash";
import moment from "moment/moment";

class MacOperatorCubeList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      totalSize: 10,
      sizePerPage: 10,
      partyId: "",
      stockList: [],
      partyList: [],
      boilManList: [],
      graderList: [],
      jangadId: "",
      machineId: "",
      status: "",
      boilManId: "",
      graderStatus: "",
      cubeList: [],
      inwardId: "",
      fillerList: [],
      fillerId: "",
      beltId: "",
      factoryId: "",
      orderId: "",
      fromDate: moment().subtract(1,"week").format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      fillerList: [],
      fillerId: "",
      name: "",
    };
  }

  async componentDidMount() {
    const partyList = await getPartyApi({
      page: null,
      limit: null,
      name: null,
      partyCode: null,
    });
    if (partyList && partyList.data) {
      this.setState({
        partyList: partyList.data.parties,
      });
    }
    const boilMan = await getUserApi({
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      roleId: "ROLE0000005",
    });
    if (boilMan && boilMan.data) {
      this.setState({
        boilManList: boilMan.data.users,
      });
    }
    const filler = await getUserApi({
      page: null,
      limit: null,
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      roleId: "ROLE0000003",
    });
    if (filler && filler.data && Array.isArray(filler.data.users)) {
      this.setState({ fillerList: filler.data.users });
    }
    const grader = await getUserApi({
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      roleId: "ROLE0000002",
    });
    if (grader && grader.data) {
      this.setState({
        graderList: grader.data.users,
      });
    }
    this.getCubeList(null);
    this.getStockList();
  }

  async getStockList() {
    const data = await getMachineOperatorStock({
      page: this.state.page,
      limit: this.state.sizePerPage,
      boilManId: this.state.boilManId,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      fillerId: this.state.fillerId,
      beltId: this.state.beltId,
      graderStatus: this.state.graderStatus,
    });
    if (data && data.data) {
      this.setState({
        totalSize: data.data.count,
        stockList:
          data.data.machineOperatorStocks.length == 0
            ? [
                {
                  id: "0",
                  jangad: {
                    cycle: 0,
                    weight: 0,
                    pieces: 0,
                    createdAt: "0",
                    factory: {
                      name: "0",
                    },
                  },
                  dataEntryGraderUser: {
                    name: "0",
                  },
                  processId: 0,
                  mainJangad: {
                    name: "0",
                    party: {
                      name: "0",
                    },
                  },
                  stockDataEntryInWard: {
                    srNo: 0,
                    pieces: 0,
                  },
                  cubeBelt:{
                    cubeId: 0,
                    processId: 0,
                    user:{
                      name: 0
                    }, 
                  },
                  stockMachineOperatorInWards:[],
                  partyName: "0",
                  weight: 0,
                  pieces: 0,
                  cycle: 0,
                  createdAt: "",
                  updatedAt: "",
                  fillerStatus: "P",
                  assignGraderToFillerStock: null,
                },
              ]
            : data.data.machineOperatorStocks,
      });
    }
  }

  async getCubeList(inputValue) {
    const stock = await getCube({
      page: 1,
      limit: 10,
      boilManId: null,
      fromDate: null,
      toDate: null,
      fillerId: this.state.fillerId,
      beltId: this.state.beltId,
      name: inputValue,
    });

    if (Array.isArray(stock.data.cubeBelts)) {
      this.setState({
        cubeList: stock.data.cubeBelts,
      });
      return [
        { label: "All", value: "" },
        ...stock.data.cubeBelts.map(x => {
          return { label: x.cubeId, value: x.id };
        }),
      ];
    } else return [];
  }
  async getBoilManList(inputValue) {
    const data = await getUserApi({
      page: null,
      limit: null,
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      name: inputValue,
      roleId: "ROLE0000005",
    });
    if (data && data.data) {
      this.setState({
        boilManList: data.data.users,
      });
    }

    if (Array.isArray(data.data.users))
      return [
        { label: "All", value: "" },
        ...data.data.users.map(x => {
          return { label: x.name, value: x.id };
        }),
      ];
    else return [];
  }

  async getFillerList(inputValue) {
    const data = await getUserApi({
      page: null,
      limit: null,
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      name: inputValue,
      roleId: "ROLE0000003",
    });
    if (data && data.data) {
      this.setState({
        fillerList: data.data.users,
      });
    }

    if (Array.isArray(data.data.users))
      return [
        { label: "All", value: "" },
        ...data.data.users.map(x => {
          return { label: x.name, value: x.id };
        }),
      ];
    else return [];
  }
  async getGraderList(inputValue) {
    const data = await getUserApi({
      page: null,
      limit: null,
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      name: inputValue,
      roleId: "ROLE0000002",
    });
    if (data && data.data) {
      this.setState({
        boilManList: data.data.users,
      });
    }

    if (Array.isArray(data.data.users))
      return [
        { label: "All", value: "" },
        ...data.data.users.map(x => {
          return { label: x.name, value: x.id };
        }),
      ];
    else return [];
  }

  render() {
    const promiseOptionsBoilMan = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getBoilManList(inputValue));
        }, 0);
      });
    const promiseOptionsFiller = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getFillerList(inputValue));
        }, 0);
      });
    const promiseOptionsGrader = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getGraderList(inputValue));
        }, 0);
      });
    const promiseOptionsCube = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getCubeList(inputValue));
        }, 0);
      });
    this.columns1 = [
      {
        dataField: "id",
        text: "#",
      },
      {
        dataField: "cubeId",
        text: `${this.props.t("Belt Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.cubeBelt.cubeId;
        },
      },
      {
        dataField: "usedCylinder",
        text: `${this.props.t("Used Cylinder")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.cubeBelt.usedCylinder;
        },
      },
      {
        dataField: "processId",
        text: `${this.props.t("Process")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.cubeBelt.process?.name;
        },
      },
      {
        dataField: "machineOperator",
        text: `${this.props.t("Machine Operator")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.cubeBelt?.machinUser?.name;
        },
      },
      {
        dataField: "remarks",
        text: this.props.t("Filler Notes"),
        sort: true,
      },
      {
        dataField: "updatedAt",
        text: `${this.props.t("Assigned Date")}`,
        sort: true,
        formatter: cell => {
          return moment(cell).format("DD/MM/YYYY");
        },
      },
      {
        dataField: "viewdetail",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) => (
          <div className="btn-group">
            <Link
              to={{
                pathname: "/machine-operator-edit-verify-accept",
                query: { isEdit: 2, data: row },
              }}
            >
              <button className="py-2 px-2 border-0 rounded">
                <img src="images/dashboard-images/edit.svg" />
              </button>
            </Link>
          </div>
        ),
      },
    ];
    this.columns1 = [
      {
        dataField: "id",
        text: "#",
      },
      {
        dataField: "cubeId",
        text: `${this.props.t("Belt Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.cubeBelt.cubeId;
        },
      },
      {
        dataField: "piece",
        text: `${this.props.t("Pieces")}`,
        sort: true,
        formatter: (cell, row) => {
          const sortedData = row.stockMachineOperatorInWards.sort((a, b) => a.id.slice(7) - b.id.slice(7));
          let html = '';
          sortedData.map((x) => { 
            html += `${x?.mainJangad?.name + '-' + x?.stockDataEntryInWard?.srNo}</br>`
          })
          return <div dangerouslySetInnerHTML={{ __html:html }} />;
        },
      },
      {
        dataField: "machineId",
        text: `${this.props.t("M.Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.machineId;
        },
      },
      {
        dataField: "processId",
        text: `${this.props.t("Process")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.cubeBelt.process?.name;
        },
      },
      {
        dataField: "machineUser",
        text: `${this.props.t("Machine Operator")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.cubeBelt?.machinUser?.name;
        },
        hidden: true,
      },
      // {
      //   dataField: "filler",
      //   text: `${this.props.t("Filler")}`,
      //   sort: true,
      //   formatter: (cell, row) => {
      //     return row.cubeBelt.user.name;
      //   },
      // },
      {
        dataField: "totalPieces",
        text: `${this.props.t("T. Pieces")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.stockMachineOperatorInWards.length;
        },
      },
      // {
      //   dataField: "graderUserId",
      //   text: "Grader Name",
      //   sort: true,
      //   formatter: (cell, row) => {
      //     if (row.graderUserId) {
      //       return row.graderUser.name
      //     } else {
      //       return "NA"
      //     }
      //   }
      // },
      {
        dataField: "boilManUserId",
        text: `${this.props.t("Boil Man")}`,
        sort: true,
        formatter: (cell, row) => {
          if (row.boilManUserId) {
            return <div className="bg-success p-2 rounded-circle d-inline-block"></div>;
          } else {
            return <div className="bg-danger p-2 rounded-circle d-inline-block"></div>
          }
        },
      },
      {
        dataField: "remarks",
        text: `${this.props.t("Filler Notes")}`,
        sort: true,
        style: (cell, row, rowIndex, colIndex) => {
          return {
            width: "6%",
            textWrap: "wrap"
          }
        },
      },
      {
        dataField: "updatedAt",
        text: `${this.props.t("Assigned Date")}`,
        sort: true,
        formatter: cell => {
          return moment(cell).format("DD/MM/YYYY");
        },
      },
      {
        dataField: "viewdetail",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) =>
          row.weight == 0 ? (
            ""
          ) : (
            <div className="btn-group">
              <Link
                to={{
                  pathname: "/machine-operator-edit-verify-accept",
                  query: { isEdit: 3, data: row },
                }}
              >
                <button className="py-2 px-2 me-2 border-0 rounded">
                  <img src="images/dashboard-images/view.svg" />
                </button>
              </Link>
              {(row.graderStatus == "NA" || row.graderStatus == "P") && (
                <Link
                  to={{
                    pathname: "/machine-operator-edit-verify-accept",
                    query: { isEdit: 2, data: row },
                  }}
                >
                  <button className="py-2 px-2 me-2 border-0 rounded">
                    <img src="images/dashboard-images/edit.svg" />
                  </button>
                </Link>
              )}

              {(row.graderStatus == "NA" || row.graderStatus == "P") &&
                (row.boilManUser?.name ? (
                  <Link
                    to={{
                      pathname: "/assign-cube-list",
                      query: { isEdit: 2, data: row },
                    }}
                  >
                    <button className="py-2 px-3 border-0 rounded">
                      Update
                    </button>
                  </Link>
                ) : (
                  (row.machineId ? (
                    <Link
                      to={{
                        pathname: "/assign-cube-list",
                        query: { isEdit: 2, data: row },
                      }}
                    >
                      <button className="py-2 px-3 border-0 rounded">
                        Assign
                      </button>
                    </Link>
                  ) : "" )
                ))}
            </div>
          ),
      },
    ];

    const defaultSorted = [
      {
        dataField: "id",
        order: "asc",
      },
    ];

    const pageOptions = {
      paginationSize: 5,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      onPageChange: (page, limit) => {
        this.setState({ page: page }, () => this.getStockList());
      },
      sizePerPageOptionRenderer: ({ text, page, onSizePerPageChange }) => {
        return (
          <li key={text} role="presentation" className="dropdown-item">
            <a
              href="#"
              className="text-dark"
              tabIndex="-1"
              role="menuitem"
              data-page={page}
              onMouseDown={e => {
                onSizePerPageChange(page);
                this.setState({ page: 1, sizePerPage: page }, () =>
                  this.getStockList()
                );
              }}
            >
              {text}
            </a>
          </li>
        );
      },
      sizePerPageList: [10, 25, 50, 100],
      page: this.state.page,
      totalSize: this.state.totalSize,
      custom: true,
    };

    const { SearchBar } = Search;

    //meta title
    document.title = "machine operator flow";

    return (
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="id"
        columns={this.columns1}
        data={this.state.stockList}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="id"
            columns={this.columns1}
            data={this.state.stockList}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <div className="page-content">
                  <div className="container-fluid">
                    <h3 className="text-black fw-bold text-uppercase">
                      {this.props.t("My Belt List")}
                    </h3>
                    <Row>
                      <Col className="col-12 mt-3">
                        <Card>
                          <CardBody>
                            <div className="d-xxl-flex d-block justify-content-between text-center text-xxl-start">
                              <div className="">
                                <h4 className="text-black fw-bold">
                                  {this.props.t("My Belt List")}
                                </h4>
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <label
                                  htmlFor="date"
                                  className="fs-5 fw-bold text-black pe-3"
                                >
                                  {this.props.t("From Date")}:
                                </label>
                                <input
                                  type="date"
                                  className="fs-5 text-black border-0"
                                  name="fromDate"
                                  value={this.state.fromDate}
                                  onChange={e =>
                                    this.setState(
                                      {
                                        stockList: [],
                                        fromDate: e.target.value,
                                      },
                                      () => this.getStockList()
                                    )
                                  }
                                />
                                <label
                                  htmlFor="date"
                                  className="fs-5 fw-bold px-0 px-md-3 text-black"
                                >
                                  {this.props.t("To Date")}:
                                </label>
                                <input
                                  type="date"
                                  className="fs-5 text-black border-0"
                                  name="toDate"
                                  value={this.state.toDate}
                                  onChange={e =>
                                    this.setState(
                                      { stockList: [], toDate: e.target.value },
                                      () => this.getStockList()
                                    )
                                  }
                                />
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Search Belt")}
                                    </label>
                                    <AsyncSelect
                                      id="jangadId"
                                      className="officestock-select d-inline-block"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            beltId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 10,
                                          },
                                          () => this.getStockList()
                                        );
                                      }}
                                      loadOptions={promiseOptionsCube}
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.cubeList.map(x => {
                                          return {
                                            value: x.id,
                                            label: x.cubeId,
                                          };
                                        }),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="d-xxl-flex d-block text-center text-xxl-start justify-content-between">
                              <div>
                                <div className="pt-3 pt-xxl-0">
                                  <p className="d-inline pe-3 fs-5">
                                    {this.props.t("Show")}
                                  </p>
                                  <div className="d-inline">
                                    <SizePerPageDropdownStandalone
                                      className=""
                                      {...paginationProps}
                                    />
                                  </div>

                                  <p className="d-inline ps-3 fs-5">
                                    {this.props.t("entries")}
                                  </p>
                                </div>
                              </div>

                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Filler Name")}
                                    </label>
                                    <AsyncSelect
                                      id="fillerId"
                                      className="officestock-select d-inline-block"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            fillerId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 10,
                                          },
                                          () => this.getStockList()
                                        );
                                      }}
                                      loadOptions={promiseOptionsFiller}
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.fillerList.map(x => {
                                          return {
                                            value: x.id,
                                            label: x.name,
                                          };
                                        }),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("BoilMan")}
                                    </label>
                                    <AsyncSelect
                                      id="boilManId"
                                      className="officestock-select d-inline-block"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            boilManId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 10,
                                          },
                                          () => this.getStockList()
                                        );
                                      }}
                                      loadOptions={promiseOptionsBoilMan}
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.boilManList.map(x => {
                                          return {
                                            value: x.id,
                                            label: x.name,
                                          };
                                        }),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <label
                                  htmlFor="search"
                                  className="pt-2 fs-5 pe-1 pe-lg-3"
                                >
                                  {this.props.t("Status")}
                                </label>

                                <Select
                                  onChange={e => {
                                    this.setState(
                                      {
                                        graderStatus: e.value,
                                        stockList: [],
                                        page: 1,
                                        sizePerPage: 10,
                                      },
                                      () => {
                                        this.getStockList();
                                      }
                                    );
                                  }}
                                  aria-labelledby="aria-label"
                                  className="officestock-select d-inline-block"
                                  inputId="aria-example-input"
                                  name="aria-live-color"
                                  onMenuOpen={this.onMenuOpen}
                                  onMenuClose={this.onMenuClose}
                                  options={[
                                    { label: "All", value: "" },
                                    { label: "Assigned", value: "A" },
                                    { label: "Pending", value: "P" },
                                    { label: "Notassign", value: "NA" },
                                  ]}
                                />
                              </div>
                            </div>

                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    remote={true}
                                    keyField={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    data={this.state.stockList}
                                    columns={this.columns1}
                                    onTableChange={() => false}
                                    defaultSorted={defaultSorted}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Col className="inner-custom-pagination mt-4 d-flex justify-content-between">
                              <div className="">
                                <h5>
                                  {this.props.t("Showing")}{" "}
                                  {(this.state.page - 1) *
                                    this.state.sizePerPage +
                                    1}
                                  -{" "}
                                  {this.state.totalSize < this.state.sizePerPage
                                    ? this.state.totalSize
                                    : this.state.sizePerPage *
                                        this.state.page >=
                                      this.state.totalSize
                                    ? this.state.totalSize
                                    : this.state.sizePerPage *
                                      this.state.page}{" "}
                                  of {this.state.totalSize}
                                </h5>
                              </div>
                              <div className="ms-auto">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    );
  }
}

export default withTranslation()(MacOperatorCubeList);
